module.exports = __webpack_public_path__ + "img/ivana-squares.967fb6f0.jpg";